import { Component } from '@angular/core';
declare var $: any;

export class HighlightRow {

  row :any;

  constructor() {}

  unHighlightRow() {
    this.row = null;
  }

  setRow(item){
    this.row = item;
  }

  highlightRow(item) {
    (item === this.row) ? this.unHighlightRow() : this.row = item;
  };

  isHighlightedRow(item) {
      return this.row === item;
  };

  resetTbl() {
    this.unHighlightRow();
    $('tbody').removeClass('tb-edit').find('tr').removeClass('row-edit selected');
  }

}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/highlight-row.ts